<template>
    <section>
        <div class="status">
            <h2>{{ title }}</h2>
            <a v-if="isEditable && isAddValueAllowed" class="add add_expand" :class="{ open: addItemOpened && isAddValueAllowed }" @click.stop="_toggleAddItem" :title="$gettext('Přidat hodnotu')" v-translate>Přidat hodnotu</a>

            <select-box
                :id="'editable_' + sortingKey"
                :options="editableOptions"
                v-model="editable"
                :disabled="!isEditable"
                @input="_editableChanged"
                :omit-label="true"
                v-if="this.settingsObject" />
        </div>

        <div class="filter expand_content" :class="{ open: addItemOpened && isAddValueAllowed }">
            <div class="field_left">
                <p class="field" v-if="!hasSelectableValues()">
                    <label :for="'input_' + sortingKey">{{ valueLabel }} *</label>
                    <input :id="'input_' + sortingKey" :name="'input_name_' + sortingKey" size="30" v-model="inputValue" type="text">
                </p>

                <select-box
                    v-else
                    :id="'new_value_' + sortingKey"
                    :options="availableValueOptions"
                    v-model="selectedItem">
                    {{ valueLabel }}
                </select-box>
            </div>

            <div class="field_right">
                <p class="field">
                    <input class="btn" type="submit" @click.stop.prevent="_addNewValue" :value="$gettext('Přidat')">
                </p>
            </div>
        </div>

        <table class="vypis vypis_detail">
            <tbody :class="['sortable_' + sortingKey, {sortable: isEditable, 'ui-sortable': isEditable}]">
                <tr :class="['sorted_' + sortingKey, {'ui-sortable-handle': isEditable}]" v-for="(value, index) in values" :key="'line_' + sortingKey + '_' + value" :rowvalue="value">
                    <td class="no_padding drag_drop"><span/></td>
                    <td class="no_padding checkbox">
                        <input
                            :id="'default_item_' + sortingKey + '_' + index"
                            @click.stop="_defaultValueChanged(value)"
                            :name="'default_' + sortingKey"
                            type="radio"
                            :checked="value === settingsObject.default"
                            :disabled="!isEditable"
                        >
                        <label :for="'default_item_' + sortingKey + '_' + index" :title="$gettext('Nastavit jako výchozí')">{{ $gettext('Výchozí') }}</label>
                    </td>
                    <td data-th="Hodnota" class="first_data">{{ _getValueName(value) }}</td>

                    <td />

                    <td class="no_padding edit" v-if="isEditable">
                        <div class="edit_inner">
                            <a class="btn btn_action btn_delete" :title="$gettext('Smazat')" @click.stop="_removeValue(value, index)">{{ $gettext('Smazat') }}</a>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tr v-if="values.length === 0">
                <td colspan="8" v-translate>Nastavení se neuplatňuje.</td>
            </tr>
        </table>
    </section>
</template>

<script>

export default {
    name: "SettingsTable",
    props: {
        isEditable: Boolean,
        title: String,
        fixedValues: Array,
        settingsObject: Object,
        valueLabel: String,
        sortingKey: String,
        nameTransformFunction: Function
    },
    mounted() {
      if (this.isEditable) {
        $('.sortable_' + this.sortingKey).sortable({
          stop: this._valuesSorted
        });
      }
    },
    data() {
        return {
            addItemOpened: false,
            inputValue: null,
            editable: this.settingsObject ? this.settingsObject.editable : false,
            selectedItem: null
        }
    },
    methods: {
        hasSelectableValues() {
            return !!this.fixedValues;
        },
        _toggleAddItem() {
            this.addItemOpened = !this.addItemOpened;
        },
        _editableChanged() {
            this.$emit('editableChanged', this.editable);
        },
        _addNewValue() {
            if (this.hasSelectableValues()) {
                if (this.selectedItem !== null) {
                    this.$emit('addValue', this.selectedItem);
                    this.selectedItem = null;
                }
            } else {
                this.$emit('addValue', this.inputValue);
                this.inputValue = null;
            }
        },
        _defaultValueChanged(value) {
            this.$emit('defaultValueChanged', value);
        },
        _removeValue(value, index) {
            this.$emit('removeValueByIndex', index);
            this.$emit('removeValue', value);
        },
        _valuesSorted() {
            const newValues = [];

            $('.sorted_' + this.sortingKey).each((el, x) => {
                newValues.push($(x).attr('rowvalue'));
            });

            this.$emit('valuesSorted', newValues);
        },
        _getValueName(value) {
            return this.nameTransformFunction ? this.$gettext(this.nameTransformFunction(value)) : value;
        }
    },
    computed: {
        values() {
            return this.settingsObject ? this.settingsObject.values : [];
        },
        editableOptions() {
            return [{
                id: false,
                text:  this.$gettext('Zakázat změny')
            }, {
                id: true,
                text:  this.$gettext('Povolit změny')
            }];
        },
        availableValues() {
            return this.fixedValues ? this.fixedValues.filter((value) => {
                return !this.values.includes(value);
            }) : [];
        },
        availableValueOptions() {
            const values = [];

            this.availableValues.forEach((value) => {
                values.push({
                    id: value,
                    text: this._getValueName(value)
                });
            });

            if (this.availableValues.length > 0 && !this.availableValues.includes(this.selectedItem)) {
                this.selectedItem = this.availableValues[0];
            }

            return values;
        },
        isAddValueAllowed() {
            return !this.hasSelectableValues() || (this.hasSelectableValues() && this.availableValues.length > 0);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SettingsTable.vue